// Internal: shared axios instance reused by lib/api.js and lib/billing.js.
// Existing lib/api.js already creates an axios client — to avoid two clients fighting
// over auth interceptors we re-export the same one here.
import { api } from './api';
export default api;
